<script>
export default {
  name: 'UlFormItemSpace',
};
</script>
<template>
  <div class="ul-form-item">
    <div class="ul-form-item__body">
      <div class="ul-form-item__input">
        <div class="ul-form-input"></div>
      </div>
    </div>
  </div>
</template>
